import MdxEditor from "features/markdown/blocks/MdxEditor";
import React, { forwardRef } from "react";

import type {
  MarkdownEditorProps,
  MarkdownEditorRef,
} from "./MarkdownEditor.types";

const MarkdownEditor = forwardRef<MarkdownEditorRef, MarkdownEditorProps>(
  (props, ref) => (
    <MdxEditor
      ref={ref}
      {...props}
    />
  ),
);

MarkdownEditor.displayName = "MarkdownEditor";

export default MarkdownEditor;
